
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    name: 'PopUpImages',

    components: {
        Swiper,
        SwiperSlide,
    },

    data() {
        return {
            swiperOptions: {
                spaceBetween: 0,
                slidesPerView: 1,
                slidesPerGroup: 1,

                keyboard: true,

                loop: true,

                navigation: {
                    prevEl: '.pop-up-images__button-navition--prev',
                    nextEl: '.pop-up-images__button-navition--next',
                },
            },
        };
    },

    computed: {
        parametrs() {
            return this.$store.state['pop-up-images'].parametrs || null;
        },
        images() {
            return this.$store.state['pop-up-images'].images || [];
        },

        open() {
            return Boolean(this.images.length > 0);
        },

        isMobileVersion() {
            if (!process.client) {
                return false;
            }
            return Boolean(window.innerWidth < 640);
        },
    },

    watch: {
        open() {
            if (this.open) {
                document.body.style.overflow = 'hidden';
                this.setActiveIndex();
            } else {
                document.body.style = '';
            }
        },
    },

    mounted() {
        window.addEventListener('keydown', (event) => {
            if (event.keyCode === 27) {
                this.close();
            }
        });
    },

    unmounted() {
        window.removeEventListener('keydown', (event) => {
            if (event.keyCode === 27) {
                this.close();
            }
        });
    },

    methods: {
        setActiveIndex() {
            if (!this.parametrs?.activeIndex) {
                return;
            }
            if (!this.$refs.refSwiper) {
                return;
            }

            this.$refs.refSwiper.$swiper.slideToLoop(this.parametrs.activeIndex, 0);
        },

        close() {
            this.$store.commit('pop-up-images/setImages', null);
        },
    },
};
